<template>
<div class="chapter">
<div class="inner_page">
<div class="images" id="image3">
<p class="booktitle">MOROCCO</p>
<p class="subtitle">A Culinary Journey with Recipes<br/>from the Spice–Scented Markets of Marrakech<br/>to the Date–Filled Oasis of Zagora</p>
<p class="author"><strong><em>text and photographs by</em><br/>JEFF KOEHLER</strong></p>
<p class="publogo"><img alt="Chronicle Books" src="images/logo.jpg"/></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 003titlepage.vue?898ef49c